import { LoaderCircle } from 'lucide-react'
import { Link } from 'react-router-dom'

const variants = {
  primary: 'button-primary',
  secondary: 'button-secondary',
  ghost: 'button-ghost',
  danger: 'button-danger',
}

export function Button({ variant = 'primary', loading = false, className = '', children, disabled, type = 'button', ...props }) {
  return (
    <button
      type={type}
      className={`button-base ${variants[variant]} ${className}`}
      disabled={disabled || loading}
      {...props}
    >
      {loading && <LoaderCircle className="size-4 animate-spin" aria-hidden="true" />}
      {children}
    </button>
  )
}

export function ButtonLink({ to, variant = 'primary', className = '', children, ...props }) {
  return (
    <Link to={to} className={`button-base ${variants[variant]} ${className}`} {...props}>
      {children}
    </Link>
  )
}

export function ExternalButtonLink({ href, variant = 'primary', className = '', children, ...props }) {
  return (
    <a href={href} className={`button-base ${variants[variant]} ${className}`} {...props}>
      {children}
    </a>
  )
}
